import { render, staticRenderFns } from "./CourseThumbBox20.vue?vue&type=template&id=6ca6b30f&scoped=true"
import script from "./CourseThumbBox20.vue?vue&type=script&lang=js"
export * from "./CourseThumbBox20.vue?vue&type=script&lang=js"
import style0 from "./CourseThumbBox20.vue?vue&type=style&index=0&id=6ca6b30f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca6b30f",
  null
  
)

export default component.exports